/**
 * This custom hook is used to get async data from BO
 * getSelectableValuesAsync() and/or getCountByIdAsync()
 */
import { useDispatch, useSelector } from 'react-redux'

import { useMode } from '../../useMode'
import { useEffectOnce } from '../../useEffectOnce'

import { cleanState } from '../../../redux/reducers/Display/display.reducer'
import { currentMarketSelector } from '../../../redux/reducers/UserConfig/userConfig.reducer'

import { getSelectableValuesAsync } from '../../../services/displayApi'
import { getCountByIdAsync } from '../../../services/countApi'

import { ModesType } from '../../../types/Modes.type'

export const useProductDisplayData = (id: string | undefined) => {
  const { mode } = useMode()
  const dispatch: any = useDispatch()

  const currentMarket: string = useSelector(currentMarketSelector)

  // Async data
  useEffectOnce(() => {
    const onMount = () => {
      if (id && mode !== ModesType.New) {
        dispatch(getSelectableValuesAsync(currentMarket)).then(() => {
          dispatch(getCountByIdAsync(id))
        })
      } else {
        dispatch(getSelectableValuesAsync(currentMarket))
      }
    }
    onMount()

    return () => {
      const onUnmount = () => {
        dispatch(cleanState())
      }
      onUnmount()
    }
  })
}
